export const countries = [
  {
    currency: "BDT",
    sign: "৳",
    countryCode: "BD",
    countryName: "Bangladesh",
    phoneCode: "+880",
    threeDigitCode: "BGD",
    flag: "https://flagcdn.com/w40/bd.png",
  },
  {
    currency: "SAR",
    sign: "ر.س",
    countryCode: "SA",
    countryName: "Saudi Arabia",
    phoneCode: "+966",
    threeDigitCode: "SAU",
    flag: "https://flagcdn.com/w40/sa.png",
  },
  {
    currency: "AED",
    sign: "د.إ",
    countryCode: "AE",
    countryName: "United Arab Emirates",
    phoneCode: "+971",
    threeDigitCode: "ARE",
    flag: "https://flagcdn.com/w40/ae.png",
  },
  {
    currency: "MYR",
    sign: "RM",
    countryCode: "MY",
    countryName: "Malaysia",
    phoneCode: "+60",
    threeDigitCode: "MYS",
    flag: "https://flagcdn.com/w40/my.png",
  },
  {
    currency: "INR",
    sign: "₹",
    countryCode: "IN",
    countryName: "India",
    phoneCode: "+91",
    threeDigitCode: "IND",
    flag: "https://flagcdn.com/w40/in.png",
  },
  {
    currency: "NPR",
    sign: "₨",
    countryCode: "NP",
    countryName: "Nepal",
    phoneCode: "+977",
    threeDigitCode: "NPL",
    flag: "https://flagcdn.com/w40/np.png",
  },
  {
    currency: "THB",
    sign: "฿",
    countryCode: "TH",
    countryName: "Thailand",
    phoneCode: "+66",
    threeDigitCode: "THA",
    flag: "https://flagcdn.com/w40/th.png",
  },
  {
    currency: "SGD",
    sign: "$",
    countryCode: "SG",
    countryName: "Singapore",
    phoneCode: "+65",
    threeDigitCode: "SGP",
    flag: "https://flagcdn.com/w40/sg.png",
  },
  {
    currency: "CNY",
    sign: "¥",
    countryCode: "CN",
    countryName: "China",
    phoneCode: "+86",
    threeDigitCode: "CHN",
    flag: "https://flagcdn.com/w40/cn.png",
  },
  {
    currency: "KWD",
    sign: "د.ك",
    countryCode: "KW",
    countryName: "Kuwait",
    phoneCode: "+965",
    threeDigitCode: "KWT",
    flag: "https://flagcdn.com/w40/kw.png",
  },
  {
    currency: "QAR",
    sign: "ر.ق",
    countryCode: "QA",
    countryName: "Qatar",
    phoneCode: "+974",
    threeDigitCode: "QAT",
    flag: "https://flagcdn.com/w40/qa.png",
  },
  {
    currency: "OMR",
    sign: "ر.ع.",
    countryCode: "OM",
    countryName: "Oman",
    phoneCode: "+968",
    threeDigitCode: "OMN",
    flag: "https://flagcdn.com/w40/om.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "DE",
    countryName: "Germany",
    phoneCode: "+49",
    threeDigitCode: "DEU",
    flag: "https://flagcdn.com/w40/de.png",
  },
  {
    currency: "USD",
    sign: "$",
    countryCode: "US",
    countryName: "United States",
    phoneCode: "+1201",
    threeDigitCode: "USA",
    flag: "https://flagcdn.com/w40/us.png",
  },
  {
    currency: "UAH",
    sign: "₴",
    countryCode: "UA",
    countryName: "Ukraine",
    phoneCode: "+380",
    threeDigitCode: "UKR",
    flag: "https://flagcdn.com/w40/ua.png",
  },
  {
    currency: "AFN",
    sign: "؋",
    countryCode: "AF",
    countryName: "Afghanistan",
    phoneCode: "+93",
    threeDigitCode: "AFG",
    flag: "https://flagcdn.com/w40/af.png",
  },

  {
    currency: "BBD",
    sign: "$",
    countryCode: "BB",
    countryName: "Barbados",
    phoneCode: "+1246",
    threeDigitCode: "BRB",
    flag: "https://flagcdn.com/w40/bb.png",
  },
  {
    currency: "SHP",
    sign: "£",
    countryCode: "GS",
    countryName: "South Georgia",
    phoneCode: "+500",
    threeDigitCode: "SGS",
    flag: "https://flagcdn.com/w40/gs.png",
  },
  {
    currency: "XCD",
    sign: "$",
    countryCode: "GD",
    countryName: "Grenada",
    phoneCode: "+1473",
    threeDigitCode: "GRD",
    flag: "https://flagcdn.com/w40/gd.png",
  },
  {
    currency: "CHF",
    sign: "Fr.",
    countryCode: "CH",
    countryName: "Switzerland",
    phoneCode: "+41",
    threeDigitCode: "CHE",
    flag: "https://flagcdn.com/w40/ch.png",
  },
  {
    currency: "SLL",
    sign: "Le",
    countryCode: "SL",
    countryName: "Sierra Leone",
    phoneCode: "+232",
    threeDigitCode: "SLE",
    flag: "https://flagcdn.com/w40/sl.png",
  },
  {
    currency: "HUF",
    sign: "Ft",
    countryCode: "HU",
    countryName: "Hungary",
    phoneCode: "+36",
    threeDigitCode: "HUN",
    flag: "https://flagcdn.com/w40/hu.png",
  },
  {
    currency: "TWD",
    sign: "$",
    countryCode: "TW",
    countryName: "Taiwan",
    phoneCode: "+886",
    threeDigitCode: "TWN",
    flag: "https://flagcdn.com/w40/tw.png",
  },
  {
    currency: "XPF",
    sign: "₣",
    countryCode: "WF",
    countryName: "Wallis and Futuna",
    phoneCode: "+681",
    threeDigitCode: "WLF",
    flag: "https://flagcdn.com/w40/wf.png",
  },

  {
    currency: "NZD",
    sign: "$",
    countryCode: "PN",
    countryName: "Pitcairn Islands",
    phoneCode: "+64",
    threeDigitCode: "PCN",
    flag: "https://flagcdn.com/w40/pn.png",
  },
  {
    currency: "XOF",
    sign: "Fr",
    countryCode: "CI",
    countryName: "Ivory Coast",
    phoneCode: "+225",
    threeDigitCode: "CIV",
    flag: "https://flagcdn.com/w40/ci.png",
  },
  {
    currency: "TND",
    sign: "د.ت",
    countryCode: "TN",
    countryName: "Tunisia",
    phoneCode: "+216",
    threeDigitCode: "TUN",
    flag: "https://flagcdn.com/w40/tn.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "IT",
    countryName: "Italy",
    phoneCode: "+39",
    threeDigitCode: "ITA",
    flag: "https://flagcdn.com/w40/it.png",
  },
  {
    currency: "XOF",
    sign: "Fr",
    countryCode: "BJ",
    countryName: "Benin",
    phoneCode: "+229",
    threeDigitCode: "BEN",
    flag: "https://flagcdn.com/w40/bj.png",
  },
  {
    currency: "IDR",
    sign: "Rp",
    countryCode: "ID",
    countryName: "Indonesia",
    phoneCode: "+62",
    threeDigitCode: "IDN",
    flag: "https://flagcdn.com/w40/id.png",
  },
  {
    currency: "CVE",
    sign: "Esc",
    countryCode: "CV",
    countryName: "Cape Verde",
    phoneCode: "+238",
    threeDigitCode: "CPV",
    flag: "https://flagcdn.com/w40/cv.png",
  },
  {
    currency: "XCD",
    sign: "$",
    countryCode: "KN",
    countryName: "Saint Kitts and Nevis",
    phoneCode: "+1869",
    threeDigitCode: "KNA",
    flag: "https://flagcdn.com/w40/kn.png",
  },
  {
    currency: "LAK",
    sign: "₭",
    countryCode: "LA",
    countryName: "Laos",
    phoneCode: "+856",
    threeDigitCode: "LAO",
    flag: "https://flagcdn.com/w40/la.png",
  },
  {
    currency: "USD",
    sign: "$",
    countryCode: "BQ",
    countryName: "Caribbean Netherlands",
    phoneCode: "+599",
    threeDigitCode: "BES",
    flag: "https://flagcdn.com/w40/bq.png",
  },
  {
    currency: "UGX",
    sign: "Sh",
    countryCode: "UG",
    countryName: "Uganda",
    phoneCode: "+256",
    threeDigitCode: "UGA",
    flag: "https://flagcdn.com/w40/ug.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "AD",
    countryName: "Andorra",
    phoneCode: "+376",
    threeDigitCode: "AND",
    flag: "https://flagcdn.com/w40/ad.png",
  },
  {
    currency: "BIF",
    sign: "Fr",
    countryCode: "BI",
    countryName: "Burundi",
    phoneCode: "+257",
    threeDigitCode: "BDI",
    flag: "https://flagcdn.com/w40/bi.png",
  },
  {
    currency: "ZAR",
    sign: "R",
    countryCode: "ZA",
    countryName: "South Africa",
    phoneCode: "+27",
    threeDigitCode: "ZAF",
    flag: "https://flagcdn.com/w40/za.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "FR",
    countryName: "France",
    phoneCode: "+33",
    threeDigitCode: "FRA",
    flag: "https://flagcdn.com/w40/fr.png",
  },
  {
    currency: "LYD",
    sign: "ل.د",
    countryCode: "LY",
    countryName: "Libya",
    phoneCode: "+218",
    threeDigitCode: "LBY",
    flag: "https://flagcdn.com/w40/ly.png",
  },
  {
    currency: "MXN",
    sign: "$",
    countryCode: "MX",
    countryName: "Mexico",
    phoneCode: "+52",
    threeDigitCode: "MEX",
    flag: "https://flagcdn.com/w40/mx.png",
  },
  {
    currency: "XAF",
    sign: "Fr",
    countryCode: "GA",
    countryName: "Gabon",
    phoneCode: "+241",
    threeDigitCode: "GAB",
    flag: "https://flagcdn.com/w40/ga.png",
  },
  {
    currency: "USD",
    sign: "$",
    countryCode: "MP",
    countryName: "Northern Mariana Islands",
    phoneCode: "+1670",
    threeDigitCode: "MNP",
    flag: "https://flagcdn.com/w40/mp.png",
  },
  {
    currency: "MKD",
    sign: "den",
    countryCode: "MK",
    countryName: "North Macedonia",
    phoneCode: "+389",
    threeDigitCode: "MKD",
    flag: "https://flagcdn.com/w40/mk.png",
  },

  {
    currency: "YER",
    sign: "﷼",
    countryCode: "YE",
    countryName: "Yemen",
    phoneCode: "+967",
    threeDigitCode: "YEM",
    flag: "https://flagcdn.com/w40/ye.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "BL",
    countryName: "Saint Barthélemy",
    phoneCode: "+590",
    threeDigitCode: "BLM",
    flag: "https://flagcdn.com/w40/bl.png",
  },
  {
    currency: "GBP",
    sign: "£",
    countryCode: "GG",
    countryName: "Guernsey",
    phoneCode: "+44",
    threeDigitCode: "GGY",
    flag: "https://flagcdn.com/w40/gg.png",
  },
  {
    currency: "SBD",
    sign: "$",
    countryCode: "SB",
    countryName: "Solomon Islands",
    phoneCode: "+677",
    threeDigitCode: "SLB",
    flag: "https://flagcdn.com/w40/sb.png",
  },
  {
    currency: "NOK",
    sign: "kr",
    countryCode: "SJ",
    countryName: "Svalbard and Jan Mayen",
    phoneCode: "+4779",
    threeDigitCode: "SJM",
    flag: "https://flagcdn.com/w40/sj.png",
  },
  {
    currency: "DKK",
    sign: "kr",
    countryCode: "FO",
    countryName: "Faroe Islands",
    phoneCode: "+298",
    threeDigitCode: "FRO",
    flag: "https://flagcdn.com/w40/fo.png",
  },
  {
    currency: "UZS",
    sign: "so'm",
    countryCode: "UZ",
    countryName: "Uzbekistan",
    phoneCode: "+998",
    threeDigitCode: "UZB",
    flag: "https://flagcdn.com/w40/uz.png",
  },
  {
    currency: "EGP",
    sign: "£",
    countryCode: "EG",
    countryName: "Egypt",
    phoneCode: "+20",
    threeDigitCode: "EGY",
    flag: "https://flagcdn.com/w40/eg.png",
  },
  {
    currency: "XOF",
    sign: "Fr",
    countryCode: "SN",
    countryName: "Senegal",
    phoneCode: "+221",
    threeDigitCode: "SEN",
    flag: "https://flagcdn.com/w40/sn.png",
  },
  {
    currency: "LKR",
    sign: "Rs  රු",
    countryCode: "LK",
    countryName: "Sri Lanka",
    phoneCode: "+94",
    threeDigitCode: "LKA",
    flag: "https://flagcdn.com/w40/lk.png",
  },
  {
    currency: "EGP",
    sign: "E£",
    countryCode: "PS",
    countryName: "Palestine",
    phoneCode: "+970",
    threeDigitCode: "PSE",
    flag: "https://flagcdn.com/w40/ps.png",
  },

  {
    currency: "PEN",
    sign: "S/ ",
    countryCode: "PE",
    countryName: "Peru",
    phoneCode: "+51",
    threeDigitCode: "PER",
    flag: "https://flagcdn.com/w40/pe.png",
  },

  {
    currency: "TRY",
    sign: "₺",
    countryCode: "TR",
    countryName: "Turkey",
    phoneCode: "+90",
    threeDigitCode: "TUR",
    flag: "https://flagcdn.com/w40/tr.png",
  },
  {
    currency: "AFN",
    sign: "؋",
    countryCode: "AF",
    countryName: "Afghanistan",
    phoneCode: "+93",
    threeDigitCode: "AFG",
    flag: "https://flagcdn.com/w40/af.png",
  },
  {
    currency: "AWG",
    sign: "ƒ",
    countryCode: "AW",
    countryName: "Aruba",
    phoneCode: "+297",
    threeDigitCode: "ABW",
    flag: "https://flagcdn.com/w40/aw.png",
  },
  {
    currency: "CKD",
    sign: "$",
    countryCode: "CK",
    countryName: "Cook Islands",
    phoneCode: "+682",
    threeDigitCode: "COK",
    flag: "https://flagcdn.com/w40/ck.png",
  },
  {
    currency: "GBP",
    sign: "£",
    countryCode: "GB",
    countryName: "United Kingdom",
    phoneCode: "+44",
    threeDigitCode: "GBR",
    flag: "https://flagcdn.com/w40/gb.png",
  },
  {
    currency: "ZMW",
    sign: "ZK",
    countryCode: "ZM",
    countryName: "Zambia",
    phoneCode: "+260",
    threeDigitCode: "ZMB",
    flag: "https://flagcdn.com/w40/zm.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "FI",
    countryName: "Finland",
    phoneCode: "+358",
    threeDigitCode: "FIN",
    flag: "https://flagcdn.com/w40/fi.png",
  },
  {
    currency: "XOF",
    sign: "Fr",
    countryCode: "NE",
    countryName: "Niger",
    phoneCode: "+227",
    threeDigitCode: "NER",
    flag: "https://flagcdn.com/w40/ne.png",
  },
  {
    currency: "AUD",
    sign: "$",
    countryCode: "CX",
    countryName: "Christmas Island",
    phoneCode: "+61",
    threeDigitCode: "CXR",
    flag: "https://flagcdn.com/w40/cx.png",
  },
  {
    currency: "NZD",
    sign: "$",
    countryCode: "TK",
    countryName: "Tokelau",
    phoneCode: "+690",
    threeDigitCode: "TKL",
    flag: "https://flagcdn.com/w40/tk.png",
  },
  {
    currency: "XOF",
    sign: "Fr",
    countryCode: "GW",
    countryName: "Guinea-Bissau",
    phoneCode: "+245",
    threeDigitCode: "GNB",
    flag: "https://flagcdn.com/w40/gw.png",
  },
  {
    currency: "AZN",
    sign: "₼",
    countryCode: "AZ",
    countryName: "Azerbaijan",
    phoneCode: "+994",
    threeDigitCode: "AZE",
    flag: "https://flagcdn.com/w40/az.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "RE",
    countryName: "Réunion",
    phoneCode: "+262",
    threeDigitCode: "REU",
    flag: "https://flagcdn.com/w40/re.png",
  },
  {
    currency: "DJF",
    sign: "Fr",
    countryCode: "DJ",
    countryName: "Djibouti",
    phoneCode: "+253",
    threeDigitCode: "DJI",
    flag: "https://flagcdn.com/w40/dj.png",
  },
  {
    currency: "KPW",
    sign: "₩",
    countryCode: "KP",
    countryName: "North Korea",
    phoneCode: "+850",
    threeDigitCode: "PRK",
    flag: "https://flagcdn.com/w40/kp.png",
  },
  {
    currency: "MUR",
    sign: "₨",
    countryCode: "MU",
    countryName: "Mauritius",
    phoneCode: "+230",
    threeDigitCode: "MUS",
    flag: "https://flagcdn.com/w40/mu.png",
  },
  {
    currency: "XCD",
    sign: "$",
    countryCode: "MS",
    countryName: "Montserrat",
    phoneCode: "+1664",
    threeDigitCode: "MSR",
    flag: "https://flagcdn.com/w40/ms.png",
  },
  {
    currency: "USD",
    sign: "$",
    countryCode: "VI",
    countryName: "United States Virgin Islands",
    phoneCode: "+1340",
    threeDigitCode: "VIR",
    flag: "https://flagcdn.com/w40/vi.png",
  },
  {
    currency: "COP",
    sign: "$",
    countryCode: "CO",
    countryName: "Colombia",
    phoneCode: "+57",
    threeDigitCode: "COL",
    flag: "https://flagcdn.com/w40/co.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "GR",
    countryName: "Greece",
    phoneCode: "+30",
    threeDigitCode: "GRC",
    flag: "https://flagcdn.com/w40/gr.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "HR",
    countryName: "Croatia",
    phoneCode: "+385",
    threeDigitCode: "HRV",
    flag: "https://flagcdn.com/w40/hr.png",
  },
  {
    currency: "MAD",
    sign: "د.م.",
    countryCode: "MA",
    countryName: "Morocco",
    phoneCode: "+212",
    threeDigitCode: "MAR",
    flag: "https://flagcdn.com/w40/ma.png",
  },
  {
    currency: "DZD",
    sign: "د.ج",
    countryCode: "DZ",
    countryName: "Algeria",
    phoneCode: "+213",
    threeDigitCode: "DZA",
    flag: "https://flagcdn.com/w40/dz.png",
  },
  {
    sign: "",
    countryCode: "AQ",
    countryName: "Antarctica",
    phoneCode: "+undefined",
    threeDigitCode: "ATA",
    flag: "https://flagcdn.com/w40/aq.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "NL",
    countryName: "Netherlands",
    phoneCode: "+31",
    threeDigitCode: "NLD",
    flag: "https://flagcdn.com/w40/nl.png",
  },
  {
    currency: "SDG",
    sign: "ج.س",
    countryCode: "SD",
    countryName: "Sudan",
    phoneCode: "+249",
    threeDigitCode: "SDN",
    flag: "https://flagcdn.com/w40/sd.png",
  },
  {
    currency: "FJD",
    sign: "$",
    countryCode: "FJ",
    countryName: "Fiji",
    phoneCode: "+679",
    threeDigitCode: "FJI",
    flag: "https://flagcdn.com/w40/fj.png",
  },
  {
    currency: "CHF",
    sign: "Fr",
    countryCode: "LI",
    countryName: "Liechtenstein",
    phoneCode: "+423",
    threeDigitCode: "LIE",
    flag: "https://flagcdn.com/w40/li.png",
  },

  {
    currency: "USD",
    sign: "$",
    countryCode: "PR",
    countryName: "Puerto Rico",
    phoneCode: "+1787",
    threeDigitCode: "PRI",
    flag: "https://flagcdn.com/w40/pr.png",
  },
  {
    currency: "GEL",
    sign: "₾",
    countryCode: "GE",
    countryName: "Georgia",
    phoneCode: "+995",
    threeDigitCode: "GEO",
    flag: "https://flagcdn.com/w40/ge.png",
  },
  {
    currency: "PKR",
    sign: "₨",
    countryCode: "PK",
    countryName: "Pakistan",
    phoneCode: "+92",
    threeDigitCode: "PAK",
    flag: "https://flagcdn.com/w40/pk.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "MC",
    countryName: "Monaco",
    phoneCode: "+377",
    threeDigitCode: "MCO",
    flag: "https://flagcdn.com/w40/mc.png",
  },
  {
    currency: "BWP",
    sign: "P",
    countryCode: "BW",
    countryName: "Botswana",
    phoneCode: "+267",
    threeDigitCode: "BWA",
    flag: "https://flagcdn.com/w40/bw.png",
  },
  {
    currency: "LBP",
    sign: "ل.ل",
    countryCode: "LB",
    countryName: "Lebanon",
    phoneCode: "+961",
    threeDigitCode: "LBN",
    flag: "https://flagcdn.com/w40/lb.png",
  },
  {
    currency: "PGK",
    sign: "K",
    countryCode: "PG",
    countryName: "Papua New Guinea",
    phoneCode: "+675",
    threeDigitCode: "PNG",
    flag: "https://flagcdn.com/w40/pg.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "YT",
    countryName: "Mayotte",
    phoneCode: "+262",
    threeDigitCode: "MYT",
    flag: "https://flagcdn.com/w40/yt.png",
  },
  {
    currency: "DOP",
    sign: "$",
    countryCode: "DO",
    countryName: "Dominican Republic",
    phoneCode: "+1809",
    threeDigitCode: "DOM",
    flag: "https://flagcdn.com/w40/do.png",
  },
  {
    currency: "AUD",
    sign: "$",
    countryCode: "NF",
    countryName: "Norfolk Island",
    phoneCode: "+672",
    threeDigitCode: "NFK",
    flag: "https://flagcdn.com/w40/nf.png",
  },
  {
    sign: "",
    countryCode: "BV",
    countryName: "Bouvet Island",
    phoneCode: "+47",
    threeDigitCode: "BVT",
    flag: "https://flagcdn.com/w40/bv.png",
  },

  {
    currency: "MGA",
    sign: "Ar",
    countryCode: "MG",
    countryName: "Madagascar",
    phoneCode: "+261",
    threeDigitCode: "MDG",
    flag: "https://flagcdn.com/w40/mg.png",
  },

  {
    currency: "SYP",
    sign: "£",
    countryCode: "SY",
    countryName: "Syria",
    phoneCode: "+963",
    threeDigitCode: "SYR",
    flag: "https://flagcdn.com/w40/sy.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "ME",
    countryName: "Montenegro",
    phoneCode: "+382",
    threeDigitCode: "MNE",
    flag: "https://flagcdn.com/w40/me.png",
  },
  {
    currency: "SZL",
    sign: "L",
    countryCode: "SZ",
    countryName: "Eswatini",
    phoneCode: "+268",
    threeDigitCode: "SWZ",
    flag: "https://flagcdn.com/w40/sz.png",
  },
  {
    currency: "PYG",
    sign: "₲",
    countryCode: "PY",
    countryName: "Paraguay",
    phoneCode: "+595",
    threeDigitCode: "PRY",
    flag: "https://flagcdn.com/w40/py.png",
  },
  {
    currency: "USD",
    sign: "$",
    countryCode: "SV",
    countryName: "El Salvador",
    phoneCode: "+503",
    threeDigitCode: "SLV",
    flag: "https://flagcdn.com/w40/sv.png",
  },
  {
    currency: "GBP",
    sign: "£",
    countryCode: "IM",
    countryName: "Isle of Man",
    phoneCode: "+44",
    threeDigitCode: "IMN",
    flag: "https://flagcdn.com/w40/im.png",
  },
  {
    currency: "NAD",
    sign: "$",
    countryCode: "NA",
    countryName: "Namibia",
    phoneCode: "+264",
    threeDigitCode: "NAM",
    flag: "https://flagcdn.com/w40/na.png",
  },

  {
    currency: "BGN",
    sign: "лв",
    countryCode: "BG",
    countryName: "Bulgaria",
    phoneCode: "+359",
    threeDigitCode: "BGR",
    flag: "https://flagcdn.com/w40/bg.png",
  },
  {
    currency: "DKK",
    sign: "kr.",
    countryCode: "GL",
    countryName: "Greenland",
    phoneCode: "+299",
    threeDigitCode: "GRL",
    flag: "https://flagcdn.com/w40/gl.png",
  },

  {
    currency: "KHR",
    sign: "៛",
    countryCode: "KH",
    countryName: "Cambodia",
    phoneCode: "+855",
    threeDigitCode: "KHM",
    flag: "https://flagcdn.com/w40/kh.png",
  },
  {
    currency: "IQD",
    sign: "ع.د",
    countryCode: "IQ",
    countryName: "Iraq",
    phoneCode: "+964",
    threeDigitCode: "IRQ",
    flag: "https://flagcdn.com/w40/iq.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "TF",
    countryName: "French Southern and Antarctic Lands",
    phoneCode: "+262",
    threeDigitCode: "ATF",
    flag: "https://flagcdn.com/w40/tf.png",
  },
  {
    currency: "SEK",
    sign: "kr",
    countryCode: "SE",
    countryName: "Sweden",
    phoneCode: "+46",
    threeDigitCode: "SWE",
    flag: "https://flagcdn.com/w40/se.png",
  },
  {
    currency: "CUC",
    sign: "$",
    countryCode: "CU",
    countryName: "Cuba",
    phoneCode: "+53",
    threeDigitCode: "CUB",
    flag: "https://flagcdn.com/w40/cu.png",
  },
  {
    currency: "KGS",
    sign: "с",
    countryCode: "KG",
    countryName: "Kyrgyzstan",
    phoneCode: "+996",
    threeDigitCode: "KGZ",
    flag: "https://flagcdn.com/w40/kg.png",
  },
  {
    currency: "RUB",
    sign: "₽",
    countryCode: "RU",
    countryName: "Russia",
    phoneCode: "+73",
    threeDigitCode: "RUS",
    flag: "https://flagcdn.com/w40/ru.png",
  },

  {
    currency: "STN",
    sign: "Db",
    countryCode: "ST",
    countryName: "São Tomé and Príncipe",
    phoneCode: "+239",
    threeDigitCode: "STP",
    flag: "https://flagcdn.com/w40/st.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "CY",
    countryName: "Cyprus",
    phoneCode: "+357",
    threeDigitCode: "CYP",
    flag: "https://flagcdn.com/w40/cy.png",
  },
  {
    currency: "CAD",
    sign: "$",
    countryCode: "CA",
    countryName: "Canada",
    phoneCode: "+1",
    threeDigitCode: "CAN",
    flag: "https://flagcdn.com/w40/ca.png",
  },
  {
    currency: "MWK",
    sign: "MK",
    countryCode: "MW",
    countryName: "Malawi",
    phoneCode: "+265",
    threeDigitCode: "MWI",
    flag: "https://flagcdn.com/w40/mw.png",
  },

  {
    currency: "BAM",
    sign: "KM",
    countryCode: "BA",
    countryName: "Bosnia and Herzegovina",
    phoneCode: "+387",
    threeDigitCode: "BIH",
    flag: "https://flagcdn.com/w40/ba.png",
  },
  {
    currency: "ETB",
    sign: "Br",
    countryCode: "ET",
    countryName: "Ethiopia",
    phoneCode: "+251",
    threeDigitCode: "ETH",
    flag: "https://flagcdn.com/w40/et.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "ES",
    countryName: "Spain",
    phoneCode: "+34",
    threeDigitCode: "ESP",
    flag: "https://flagcdn.com/w40/es.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "SI",
    countryName: "Slovenia",
    phoneCode: "+386",
    threeDigitCode: "SVN",
    flag: "https://flagcdn.com/w40/si.png",
  },

  {
    currency: "EUR",
    sign: "€",
    countryCode: "PM",
    countryName: "Saint Pierre and Miquelon",
    phoneCode: "+508",
    threeDigitCode: "SPM",
    flag: "https://flagcdn.com/w40/pm.png",
  },
  {
    currency: "MOP",
    sign: "P",
    countryCode: "MO",
    countryName: "Macau",
    phoneCode: "+853",
    threeDigitCode: "MAC",
    flag: "https://flagcdn.com/w40/mo.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "SM",
    countryName: "San Marino",
    phoneCode: "+378",
    threeDigitCode: "SMR",
    flag: "https://flagcdn.com/w40/sm.png",
  },
  {
    currency: "LSL",
    sign: "L",
    countryCode: "LS",
    countryName: "Lesotho",
    phoneCode: "+266",
    threeDigitCode: "LSO",
    flag: "https://flagcdn.com/w40/ls.png",
  },
  {
    currency: "USD",
    sign: "$",
    countryCode: "MH",
    countryName: "Marshall Islands",
    phoneCode: "+692",
    threeDigitCode: "MHL",
    flag: "https://flagcdn.com/w40/mh.png",
  },
  {
    currency: "ANG",
    sign: "ƒ",
    countryCode: "SX",
    countryName: "Sint Maarten",
    phoneCode: "+1721",
    threeDigitCode: "SXM",
    flag: "https://flagcdn.com/w40/sx.png",
  },
  {
    currency: "ISK",
    sign: "kr",
    countryCode: "IS",
    countryName: "Iceland",
    phoneCode: "+354",
    threeDigitCode: "ISL",
    flag: "https://flagcdn.com/w40/is.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "LU",
    countryName: "Luxembourg",
    phoneCode: "+352",
    threeDigitCode: "LUX",
    flag: "https://flagcdn.com/w40/lu.png",
  },
  {
    currency: "ARS",
    sign: "$",
    countryCode: "AR",
    countryName: "Argentina",
    phoneCode: "+54",
    threeDigitCode: "ARG",
    flag: "https://flagcdn.com/w40/ar.png",
  },
  {
    currency: "USD",
    sign: "$",
    countryCode: "TC",
    countryName: "Turks and Caicos Islands",
    phoneCode: "+1649",
    threeDigitCode: "TCA",
    flag: "https://flagcdn.com/w40/tc.png",
  },
  {
    currency: "AUD",
    sign: "$",
    countryCode: "NR",
    countryName: "Nauru",
    phoneCode: "+674",
    threeDigitCode: "NRU",
    flag: "https://flagcdn.com/w40/nr.png",
  },
  {
    currency: "AUD",
    sign: "$",
    countryCode: "CC",
    countryName: "Cocos (Keeling) Islands",
    phoneCode: "+61",
    threeDigitCode: "CCK",
    flag: "https://flagcdn.com/w40/cc.png",
  },
  {
    currency: "DZD",
    sign: "دج",
    countryCode: "EH",
    countryName: "Western Sahara",
    phoneCode: "+2125288",
    threeDigitCode: "ESH",
    flag: "https://flagcdn.com/w40/eh.png",
  },
  {
    currency: "XCD",
    sign: "$",
    countryCode: "DM",
    countryName: "Dominica",
    phoneCode: "+1767",
    threeDigitCode: "DMA",
    flag: "https://flagcdn.com/w40/dm.png",
  },
  {
    currency: "CRC",
    sign: "₡",
    countryCode: "CR",
    countryName: "Costa Rica",
    phoneCode: "+506",
    threeDigitCode: "CRI",
    flag: "https://flagcdn.com/w40/cr.png",
  },
  {
    currency: "AUD",
    sign: "$",
    countryCode: "AU",
    countryName: "Australia",
    phoneCode: "+61",
    threeDigitCode: "AUS",
    flag: "https://flagcdn.com/w40/au.png",
  },

  {
    currency: "HTG",
    sign: "G",
    countryCode: "HT",
    countryName: "Haiti",
    phoneCode: "+509",
    threeDigitCode: "HTI",
    flag: "https://flagcdn.com/w40/ht.png",
  },
  {
    currency: "AUD",
    sign: "$",
    countryCode: "TV",
    countryName: "Tuvalu",
    phoneCode: "+688",
    threeDigitCode: "TUV",
    flag: "https://flagcdn.com/w40/tv.png",
  },
  {
    currency: "HNL",
    sign: "L",
    countryCode: "HN",
    countryName: "Honduras",
    phoneCode: "+504",
    threeDigitCode: "HND",
    flag: "https://flagcdn.com/w40/hn.png",
  },
  {
    currency: "XAF",
    sign: "Fr",
    countryCode: "GQ",
    countryName: "Equatorial Guinea",
    phoneCode: "+240",
    threeDigitCode: "GNQ",
    flag: "https://flagcdn.com/w40/gq.png",
  },
  {
    currency: "XCD",
    sign: "$",
    countryCode: "LC",
    countryName: "Saint Lucia",
    phoneCode: "+1758",
    threeDigitCode: "LCA",
    flag: "https://flagcdn.com/w40/lc.png",
  },
  {
    currency: "XPF",
    sign: "₣",
    countryCode: "PF",
    countryName: "French Polynesia",
    phoneCode: "+689",
    threeDigitCode: "PYF",
    flag: "https://flagcdn.com/w40/pf.png",
  },
  {
    currency: "BYN",
    sign: "Br",
    countryCode: "BY",
    countryName: "Belarus",
    phoneCode: "+375",
    threeDigitCode: "BLR",
    flag: "https://flagcdn.com/w40/by.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "LV",
    countryName: "Latvia",
    phoneCode: "+371",
    threeDigitCode: "LVA",
    flag: "https://flagcdn.com/w40/lv.png",
  },
  {
    currency: "USD",
    sign: "$",
    countryCode: "PW",
    countryName: "Palau",
    phoneCode: "+680",
    threeDigitCode: "PLW",
    flag: "https://flagcdn.com/w40/pw.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "GP",
    countryName: "Guadeloupe",
    phoneCode: "+590",
    threeDigitCode: "GLP",
    flag: "https://flagcdn.com/w40/gp.png",
  },
  {
    currency: "PHP",
    sign: "₱",
    countryCode: "PH",
    countryName: "Philippines",
    phoneCode: "+63",
    threeDigitCode: "PHL",
    flag: "https://flagcdn.com/w40/ph.png",
  },
  {
    currency: "GIP",
    sign: "£",
    countryCode: "GI",
    countryName: "Gibraltar",
    phoneCode: "+350",
    threeDigitCode: "GIB",
    flag: "https://flagcdn.com/w40/gi.png",
  },
  {
    currency: "DKK",
    sign: "kr",
    countryCode: "DK",
    countryName: "Denmark",
    phoneCode: "+45",
    threeDigitCode: "DNK",
    flag: "https://flagcdn.com/w40/dk.png",
  },
  {
    currency: "XAF",
    sign: "Fr",
    countryCode: "CM",
    countryName: "Cameroon",
    phoneCode: "+237",
    threeDigitCode: "CMR",
    flag: "https://flagcdn.com/w40/cm.png",
  },
  {
    currency: "GNF",
    sign: "Fr",
    countryCode: "GN",
    countryName: "Guinea",
    phoneCode: "+224",
    threeDigitCode: "GIN",
    flag: "https://flagcdn.com/w40/gn.png",
  },
  {
    currency: "BHD",
    sign: ".د.ب",
    countryCode: "BH",
    countryName: "Bahrain",
    phoneCode: "+973",
    threeDigitCode: "BHR",
    flag: "https://flagcdn.com/w40/bh.png",
  },
  {
    currency: "SRD",
    sign: "$",
    countryCode: "SR",
    countryName: "Suriname",
    phoneCode: "+597",
    threeDigitCode: "SUR",
    flag: "https://flagcdn.com/w40/sr.png",
  },
  {
    currency: "CDF",
    sign: "FC",
    countryCode: "CD",
    countryName: "DR Congo",
    phoneCode: "+243",
    threeDigitCode: "COD",
    flag: "https://flagcdn.com/w40/cd.png",
  },
  {
    currency: "SOS",
    sign: "Sh",
    countryCode: "SO",
    countryName: "Somalia",
    phoneCode: "+252",
    threeDigitCode: "SOM",
    flag: "https://flagcdn.com/w40/so.png",
  },
  {
    currency: "CZK",
    sign: "Kč",
    countryCode: "CZ",
    countryName: "Czechia",
    phoneCode: "+420",
    threeDigitCode: "CZE",
    flag: "https://flagcdn.com/w40/cz.png",
  },
  {
    currency: "XPF",
    sign: "₣",
    countryCode: "NC",
    countryName: "New Caledonia",
    phoneCode: "+687",
    threeDigitCode: "NCL",
    flag: "https://flagcdn.com/w40/nc.png",
  },
  {
    currency: "VUV",
    sign: "Vt",
    countryCode: "VU",
    countryName: "Vanuatu",
    phoneCode: "+678",
    threeDigitCode: "VUT",
    flag: "https://flagcdn.com/w40/vu.png",
  },
  {
    currency: "GBP",
    sign: "£",
    countryCode: "SH",
    countryName: "Saint Helena, Ascension and Tristan da Cunha",
    phoneCode: "+290",
    threeDigitCode: "SHN",
    flag: "https://flagcdn.com/w40/sh.png",
  },
  {
    currency: "XOF",
    sign: "Fr",
    countryCode: "TG",
    countryName: "Togo",
    phoneCode: "+228",
    threeDigitCode: "TGO",
    flag: "https://flagcdn.com/w40/tg.png",
  },
  {
    currency: "USD",
    sign: "$",
    countryCode: "VG",
    countryName: "British Virgin Islands",
    phoneCode: "+1284",
    threeDigitCode: "VGB",
    flag: "https://flagcdn.com/w40/vg.png",
  },
  {
    currency: "KES",
    sign: "Sh",
    countryCode: "KE",
    countryName: "Kenya",
    phoneCode: "+254",
    threeDigitCode: "KEN",
    flag: "https://flagcdn.com/w40/ke.png",
  },
  {
    currency: "NZD",
    sign: "$",
    countryCode: "NU",
    countryName: "Niue",
    phoneCode: "+683",
    threeDigitCode: "NIU",
    flag: "https://flagcdn.com/w40/nu.png",
  },
  {
    sign: "",
    countryCode: "HM",
    countryName: "Heard Island and McDonald Islands",
    phoneCode: "+undefined",
    threeDigitCode: "HMD",
    flag: "https://flagcdn.com/w40/hm.png",
  },
  {
    currency: "RWF",
    sign: "Fr",
    countryCode: "RW",
    countryName: "Rwanda",
    phoneCode: "+250",
    threeDigitCode: "RWA",
    flag: "https://flagcdn.com/w40/rw.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "EE",
    countryName: "Estonia",
    phoneCode: "+372",
    threeDigitCode: "EST",
    flag: "https://flagcdn.com/w40/ee.png",
  },
  {
    currency: "RON",
    sign: "lei",
    countryCode: "RO",
    countryName: "Romania",
    phoneCode: "+40",
    threeDigitCode: "ROU",
    flag: "https://flagcdn.com/w40/ro.png",
  },
  {
    currency: "TTD",
    sign: "$",
    countryCode: "TT",
    countryName: "Trinidad and Tobago",
    phoneCode: "+1868",
    threeDigitCode: "TTO",
    flag: "https://flagcdn.com/w40/tt.png",
  },
  {
    currency: "GYD",
    sign: "$",
    countryCode: "GY",
    countryName: "Guyana",
    phoneCode: "+592",
    threeDigitCode: "GUY",
    flag: "https://flagcdn.com/w40/gy.png",
  },
  {
    currency: "USD",
    sign: "$",
    countryCode: "TL",
    countryName: "Timor-Leste",
    phoneCode: "+670",
    threeDigitCode: "TLS",
    flag: "https://flagcdn.com/w40/tl.png",
  },
  {
    currency: "VND",
    sign: "₫",
    countryCode: "VN",
    countryName: "Vietnam",
    phoneCode: "+84",
    threeDigitCode: "VNM",
    flag: "https://flagcdn.com/w40/vn.png",
  },
  {
    currency: "UYU",
    sign: "$",
    countryCode: "UY",
    countryName: "Uruguay",
    phoneCode: "+598",
    threeDigitCode: "URY",
    flag: "https://flagcdn.com/w40/uy.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "VA",
    countryName: "Vatican City",
    phoneCode: "+3906698",
    threeDigitCode: "VAT",
    flag: "https://flagcdn.com/w40/va.png",
  },
  {
    currency: "HKD",
    sign: "$",
    countryCode: "HK",
    countryName: "Hong Kong",
    phoneCode: "+852",
    threeDigitCode: "HKG",
    flag: "https://flagcdn.com/w40/hk.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "AT",
    countryName: "Austria",
    phoneCode: "+43",
    threeDigitCode: "AUT",
    flag: "https://flagcdn.com/w40/at.png",
  },
  {
    currency: "XCD",
    sign: "$",
    countryCode: "AG",
    countryName: "Antigua and Barbuda",
    phoneCode: "+1268",
    threeDigitCode: "ATG",
    flag: "https://flagcdn.com/w40/ag.png",
  },
  {
    currency: "TMT",
    sign: "m",
    countryCode: "TM",
    countryName: "Turkmenistan",
    phoneCode: "+993",
    threeDigitCode: "TKM",
    flag: "https://flagcdn.com/w40/tm.png",
  },
  {
    currency: "MZN",
    sign: "MT",
    countryCode: "MZ",
    countryName: "Mozambique",
    phoneCode: "+258",
    threeDigitCode: "MOZ",
    flag: "https://flagcdn.com/w40/mz.png",
  },
  {
    currency: "PAB",
    sign: "B/.",
    countryCode: "PA",
    countryName: "Panama",
    phoneCode: "+507",
    threeDigitCode: "PAN",
    flag: "https://flagcdn.com/w40/pa.png",
  },
  {
    currency: "USD",
    sign: "$",
    countryCode: "FM",
    countryName: "Micronesia",
    phoneCode: "+691",
    threeDigitCode: "FSM",
    flag: "https://flagcdn.com/w40/fm.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "IE",
    countryName: "Ireland",
    phoneCode: "+353",
    threeDigitCode: "IRL",
    flag: "https://flagcdn.com/w40/ie.png",
  },
  {
    currency: "ANG",
    sign: "ƒ",
    countryCode: "CW",
    countryName: "Curaçao",
    phoneCode: "+599",
    threeDigitCode: "CUW",
    flag: "https://flagcdn.com/w40/cw.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "GF",
    countryName: "French Guiana",
    phoneCode: "+594",
    threeDigitCode: "GUF",
    flag: "https://flagcdn.com/w40/gf.png",
  },
  {
    currency: "NOK",
    sign: "kr",
    countryCode: "NO",
    countryName: "Norway",
    phoneCode: "+47",
    threeDigitCode: "NOR",
    flag: "https://flagcdn.com/w40/no.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "AX",
    countryName: "Åland Islands",
    phoneCode: "+35818",
    threeDigitCode: "ALA",
    flag: "https://flagcdn.com/w40/ax.png",
  },
  {
    currency: "XAF",
    sign: "Fr",
    countryCode: "CF",
    countryName: "Central African Republic",
    phoneCode: "+236",
    threeDigitCode: "CAF",
    flag: "https://flagcdn.com/w40/cf.png",
  },
  {
    currency: "XOF",
    sign: "Fr",
    countryCode: "BF",
    countryName: "Burkina Faso",
    phoneCode: "+226",
    threeDigitCode: "BFA",
    flag: "https://flagcdn.com/w40/bf.png",
  },
  {
    currency: "ERN",
    sign: "Nfk",
    countryCode: "ER",
    countryName: "Eritrea",
    phoneCode: "+291",
    threeDigitCode: "ERI",
    flag: "https://flagcdn.com/w40/er.png",
  },
  {
    currency: "TZS",
    sign: "Sh",
    countryCode: "TZ",
    countryName: "Tanzania",
    phoneCode: "+255",
    threeDigitCode: "TZA",
    flag: "https://flagcdn.com/w40/tz.png",
  },
  {
    currency: "KRW",
    sign: "₩",
    countryCode: "KR",
    countryName: "South Korea",
    phoneCode: "+82",
    threeDigitCode: "KOR",
    flag: "https://flagcdn.com/w40/kr.png",
  },
  {
    currency: "JOD",
    sign: "د.ا",
    countryCode: "JO",
    countryName: "Jordan",
    phoneCode: "+962",
    threeDigitCode: "JOR",
    flag: "https://flagcdn.com/w40/jo.png",
  },
  {
    currency: "MRU",
    sign: "UM",
    countryCode: "MR",
    countryName: "Mauritania",
    phoneCode: "+222",
    threeDigitCode: "MRT",
    flag: "https://flagcdn.com/w40/mr.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "LT",
    countryName: "Lithuania",
    phoneCode: "+370",
    threeDigitCode: "LTU",
    flag: "https://flagcdn.com/w40/lt.png",
  },
  {
    currency: "USD",
    sign: "$",
    countryCode: "UM",
    countryName: "United States Minor Outlying Islands",
    phoneCode: "+268",
    threeDigitCode: "UMI",
    flag: "https://flagcdn.com/w40/um.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "SK",
    countryName: "Slovakia",
    phoneCode: "+421",
    threeDigitCode: "SVK",
    flag: "https://flagcdn.com/w40/sk.png",
  },
  {
    currency: "AOA",
    sign: "Kz",
    countryCode: "AO",
    countryName: "Angola",
    phoneCode: "+244",
    threeDigitCode: "AGO",
    flag: "https://flagcdn.com/w40/ao.png",
  },
  {
    currency: "KZT",
    sign: "₸",
    countryCode: "KZ",
    countryName: "Kazakhstan",
    phoneCode: "+76",
    threeDigitCode: "KAZ",
    flag: "https://flagcdn.com/w40/kz.png",
  },
  {
    currency: "MDL",
    sign: "L",
    countryCode: "MD",
    countryName: "Moldova",
    phoneCode: "+373",
    threeDigitCode: "MDA",
    flag: "https://flagcdn.com/w40/md.png",
  },
  {
    currency: "XOF",
    sign: "Fr",
    countryCode: "ML",
    countryName: "Mali",
    phoneCode: "+223",
    threeDigitCode: "MLI",
    flag: "https://flagcdn.com/w40/ml.png",
  },
  {
    currency: "FKP",
    sign: "£",
    countryCode: "FK",
    countryName: "Falkland Islands",
    phoneCode: "+500",
    threeDigitCode: "FLK",
    flag: "https://flagcdn.com/w40/fk.png",
  },
  {
    currency: "AMD",
    sign: "֏",
    countryCode: "AM",
    countryName: "Armenia",
    phoneCode: "+374",
    threeDigitCode: "ARM",
    flag: "https://flagcdn.com/w40/am.png",
  },
  {
    currency: "WST",
    sign: "T",
    countryCode: "WS",
    countryName: "Samoa",
    phoneCode: "+685",
    threeDigitCode: "WSM",
    flag: "https://flagcdn.com/w40/ws.png",
  },
  {
    currency: "GBP",
    sign: "£",
    countryCode: "JE",
    countryName: "Jersey",
    phoneCode: "+44",
    threeDigitCode: "JEY",
    flag: "https://flagcdn.com/w40/je.png",
  },
  {
    currency: "JPY",
    sign: "¥",
    countryCode: "JP",
    countryName: "Japan",
    phoneCode: "+81",
    threeDigitCode: "JPN",
    flag: "https://flagcdn.com/w40/jp.png",
  },
  {
    currency: "BOB",
    sign: "Bs.",
    countryCode: "BO",
    countryName: "Bolivia",
    phoneCode: "+591",
    threeDigitCode: "BOL",
    flag: "https://flagcdn.com/w40/bo.png",
  },
  {
    currency: "CLP",
    sign: "$",
    countryCode: "CL",
    countryName: "Chile",
    phoneCode: "+56",
    threeDigitCode: "CHL",
    flag: "https://flagcdn.com/w40/cl.png",
  },

  {
    currency: "XCD",
    sign: "$",
    countryCode: "VC",
    countryName: "Saint Vincent and the Grenadines",
    phoneCode: "+1784",
    threeDigitCode: "VCT",
    flag: "https://flagcdn.com/w40/vc.png",
  },
  {
    currency: "BMD",
    sign: "$",
    countryCode: "BM",
    countryName: "Bermuda",
    phoneCode: "+1441",
    threeDigitCode: "BMU",
    flag: "https://flagcdn.com/w40/bm.png",
  },
  {
    currency: "SCR",
    sign: "₨",
    countryCode: "SC",
    countryName: "Seychelles",
    phoneCode: "+248",
    threeDigitCode: "SYC",
    flag: "https://flagcdn.com/w40/sc.png",
  },
  {
    currency: "USD",
    sign: "$",
    countryCode: "IO",
    countryName: "British Indian Ocean Territory",
    phoneCode: "+246",
    threeDigitCode: "IOT",
    flag: "https://flagcdn.com/w40/io.png",
  },
  {
    currency: "GTQ",
    sign: "Q",
    countryCode: "GT",
    countryName: "Guatemala",
    phoneCode: "+502",
    threeDigitCode: "GTM",
    flag: "https://flagcdn.com/w40/gt.png",
  },
  {
    currency: "USD",
    sign: "$",
    countryCode: "EC",
    countryName: "Ecuador",
    phoneCode: "+593",
    threeDigitCode: "ECU",
    flag: "https://flagcdn.com/w40/ec.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "MQ",
    countryName: "Martinique",
    phoneCode: "+596",
    threeDigitCode: "MTQ",
    flag: "https://flagcdn.com/w40/mq.png",
  },
  {
    currency: "TJS",
    sign: "ЅМ",
    countryCode: "TJ",
    countryName: "Tajikistan",
    phoneCode: "+992",
    threeDigitCode: "TJK",
    flag: "https://flagcdn.com/w40/tj.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "MT",
    countryName: "Malta",
    phoneCode: "+356",
    threeDigitCode: "MLT",
    flag: "https://flagcdn.com/w40/mt.png",
  },
  {
    currency: "GMD",
    sign: "D",
    countryCode: "GM",
    countryName: "Gambia",
    phoneCode: "+220",
    threeDigitCode: "GMB",
    flag: "https://flagcdn.com/w40/gm.png",
  },
  {
    currency: "NGN",
    sign: "₦",
    countryCode: "NG",
    countryName: "Nigeria",
    phoneCode: "+234",
    threeDigitCode: "NGA",
    flag: "https://flagcdn.com/w40/ng.png",
  },
  {
    currency: "BSD",
    sign: "$",
    countryCode: "BS",
    countryName: "Bahamas",
    phoneCode: "+1242",
    threeDigitCode: "BHS",
    flag: "https://flagcdn.com/w40/bs.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "XK",
    countryName: "Kosovo",
    phoneCode: "+383",
    threeDigitCode: "UNK",
    flag: "https://flagcdn.com/w40/xk.png",
  },

  {
    currency: "MVR",
    sign: ".ރ",
    countryCode: "MV",
    countryName: "Maldives",
    phoneCode: "+960",
    threeDigitCode: "MDV",
    flag: "https://flagcdn.com/w40/mv.png",
  },
  {
    currency: "SSP",
    sign: "£",
    countryCode: "SS",
    countryName: "South Sudan",
    phoneCode: "+211",
    threeDigitCode: "SSD",
    flag: "https://flagcdn.com/w40/ss.png",
  },
  {
    currency: "IRR",
    sign: "﷼",
    countryCode: "IR",
    countryName: "Iran",
    phoneCode: "+98",
    threeDigitCode: "IRN",
    flag: "https://flagcdn.com/w40/ir.png",
  },
  {
    currency: "ALL",
    sign: "L",
    countryCode: "AL",
    countryName: "Albania",
    phoneCode: "+355",
    threeDigitCode: "ALB",
    flag: "https://flagcdn.com/w40/al.png",
  },
  {
    currency: "BRL",
    sign: "R$",
    countryCode: "BR",
    countryName: "Brazil",
    phoneCode: "+55",
    threeDigitCode: "BRA",
    flag: "https://flagcdn.com/w40/br.png",
  },
  {
    currency: "RSD",
    sign: "дин.",
    countryCode: "RS",
    countryName: "Serbia",
    phoneCode: "+381",
    threeDigitCode: "SRB",
    flag: "https://flagcdn.com/w40/rs.png",
  },
  {
    currency: "BZD",
    sign: "$",
    countryCode: "BZ",
    countryName: "Belize",
    phoneCode: "+501",
    threeDigitCode: "BLZ",
    flag: "https://flagcdn.com/w40/bz.png",
  },
  {
    currency: "MMK",
    sign: "Ks",
    countryCode: "MM",
    countryName: "Myanmar",
    phoneCode: "+95",
    threeDigitCode: "MMR",
    flag: "https://flagcdn.com/w40/mm.png",
  },
  {
    currency: "BTN",
    sign: "Nu.",
    countryCode: "BT",
    countryName: "Bhutan",
    phoneCode: "+975",
    threeDigitCode: "BTN",
    flag: "https://flagcdn.com/w40/bt.png",
  },
  {
    currency: "VES",
    sign: "Bs.S.",
    countryCode: "VE",
    countryName: "Venezuela",
    phoneCode: "+58",
    threeDigitCode: "VEN",
    flag: "https://flagcdn.com/w40/ve.png",
  },
  {
    currency: "LRD",
    sign: "$",
    countryCode: "LR",
    countryName: "Liberia",
    phoneCode: "+231",
    threeDigitCode: "LBR",
    flag: "https://flagcdn.com/w40/lr.png",
  },
  {
    currency: "JMD",
    sign: "$",
    countryCode: "JM",
    countryName: "Jamaica",
    phoneCode: "+1876",
    threeDigitCode: "JAM",
    flag: "https://flagcdn.com/w40/jm.png",
  },
  {
    currency: "PLN",
    sign: "zł",
    countryCode: "PL",
    countryName: "Poland",
    phoneCode: "+48",
    threeDigitCode: "POL",
    flag: "https://flagcdn.com/w40/pl.png",
  },
  {
    currency: "KYD",
    sign: "$",
    countryCode: "KY",
    countryName: "Cayman Islands",
    phoneCode: "+1345",
    threeDigitCode: "CYM",
    flag: "https://flagcdn.com/w40/ky.png",
  },
  {
    currency: "BND",
    sign: "$",
    countryCode: "BN",
    countryName: "Brunei",
    phoneCode: "+673",
    threeDigitCode: "BRN",
    flag: "https://flagcdn.com/w40/bn.png",
  },
  {
    currency: "KMF",
    sign: "Fr",
    countryCode: "KM",
    countryName: "Comoros",
    phoneCode: "+269",
    threeDigitCode: "COM",
    flag: "https://flagcdn.com/w40/km.png",
  },
  {
    currency: "USD",
    sign: "$",
    countryCode: "GU",
    countryName: "Guam",
    phoneCode: "+1671",
    threeDigitCode: "GUM",
    flag: "https://flagcdn.com/w40/gu.png",
  },
  {
    currency: "TOP",
    sign: "T$",
    countryCode: "TO",
    countryName: "Tonga",
    phoneCode: "+676",
    threeDigitCode: "TON",
    flag: "https://flagcdn.com/w40/to.png",
  },
  {
    currency: "AUD",
    sign: "$",
    countryCode: "KI",
    countryName: "Kiribati",
    phoneCode: "+686",
    threeDigitCode: "KIR",
    flag: "https://flagcdn.com/w40/ki.png",
  },
  {
    currency: "GHS",
    sign: "₵",
    countryCode: "GH",
    countryName: "Ghana",
    phoneCode: "+233",
    threeDigitCode: "GHA",
    flag: "https://flagcdn.com/w40/gh.png",
  },
  {
    currency: "XAF",
    sign: "Fr",
    countryCode: "TD",
    countryName: "Chad",
    phoneCode: "+235",
    threeDigitCode: "TCD",
    flag: "https://flagcdn.com/w40/td.png",
  },
  {
    currency: "ZWL",
    sign: "$",
    countryCode: "ZW",
    countryName: "Zimbabwe",
    phoneCode: "+263",
    threeDigitCode: "ZWE",
    flag: "https://flagcdn.com/w40/zw.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "MF",
    countryName: "Saint Martin",
    phoneCode: "+590",
    threeDigitCode: "MAF",
    flag: "https://flagcdn.com/w40/mf.png",
  },
  {
    currency: "MNT",
    sign: "₮",
    countryCode: "MN",
    countryName: "Mongolia",
    phoneCode: "+976",
    threeDigitCode: "MNG",
    flag: "https://flagcdn.com/w40/mn.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "PT",
    countryName: "Portugal",
    phoneCode: "+351",
    threeDigitCode: "PRT",
    flag: "https://flagcdn.com/w40/pt.png",
  },
  {
    currency: "USD",
    sign: "$",
    countryCode: "AS",
    countryName: "American Samoa",
    phoneCode: "+1684",
    threeDigitCode: "ASM",
    flag: "https://flagcdn.com/w40/as.png",
  },
  {
    currency: "XAF",
    sign: "Fr",
    countryCode: "CG",
    countryName: "Republic of the Congo",
    phoneCode: "+242",
    threeDigitCode: "COG",
    flag: "https://flagcdn.com/w40/cg.png",
  },
  {
    currency: "EUR",
    sign: "€",
    countryCode: "BE",
    countryName: "Belgium",
    phoneCode: "+32",
    threeDigitCode: "BEL",
    flag: "https://flagcdn.com/w40/be.png",
  },
  {
    currency: "ILS",
    sign: "₪",
    countryCode: "IL",
    countryName: "Israel",
    phoneCode: "+972",
    threeDigitCode: "ISR",
    flag: "https://flagcdn.com/w40/il.png",
  },
  {
    currency: "NZD",
    sign: "$",
    countryCode: "NZ",
    countryName: "New Zealand",
    phoneCode: "+64",
    threeDigitCode: "NZL",
    flag: "https://flagcdn.com/w40/nz.png",
  },
  {
    currency: "NIO",
    sign: "C$",
    countryCode: "NI",
    countryName: "Nicaragua",
    phoneCode: "+505",
    threeDigitCode: "NIC",
    flag: "https://flagcdn.com/w40/ni.png",
  },
  {
    currency: "XCD",
    sign: "$",
    countryCode: "AI",
    countryName: "Anguilla",
    phoneCode: "+1264",
    threeDigitCode: "AIA",
    flag: "https://flagcdn.com/w40/ai.png",
  },
];
